export default "__VITE_ASSET__Cyi9AvL0__"